import React from 'react'

const ComingSoon = () => {
    return (
        <div className='coming-soon-div d-flex align-items-center justify-content-center'>
            <h4>Coming Soon</h4>
        </div>
    )
}

export default ComingSoon;
